import React from "react";
import ValueCard from "../../ValueCard/ValueCard";
import ActiveCampaignPanel from "../../ActiveCampaigns/ActiveCampaignPanel";
import ClicksVisitsLineGraph from "../../ClicksVisitsLineGraph/ClickVisitsLineGraph";
import BumpGraph from "../../BumpGraph/BumpGraph";
import "./CurrentTile.scss";
import Tile from "../../../../SharedComponents/Layout/Tile/Tile";
import { useSelector, useDispatch } from "react-redux";
import CurrentData from "../Data/CurrentData";
import Loader from "../../../../SharedComponents/Loader/Loader";
import { formatNumber, formatCurrency } from "../../../../Utils/utils";
import { Adnetworks } from "../../Constants";
import GraphsToolTip from "../../../../SharedComponents/GraphsToolTip/GraphsToolTip";
import TrafficFunnel from "../../TrafficFunnel";
import IncreaseIndicator from "../../IncreaseIndicator/IncreaseIndicator";
import { MaxIcon } from "../../../../SVG/MaxIcon";
import GraphModal from "../../../../SharedComponents/GraphModal/GraphModal";
import Breadcrumb from "../../Breadcrumb";

const CurrentTile = ({ campaignId, linkId, adType = -1 }) => {
    adType = parseInt(adType);
    const [loading, setLoading] = React.useState(false);
    const [error, setError] = React.useState('');
    const currentData = useSelector(state => state.currentData.data) || {};
    const [supportLink, setSupportLink] = React.useState("");
    const primaryUser = localStorage.getItem("primaryUser") === "true";
    const adNetworks = useSelector(state => state.currentData.selectedNetworks) || [];
    const timeRangeRedux = useSelector(state => state.currentData.timeRange);
    const [timeRange, setTimeRange] = React.useState({ timeRange: timeRangeRedux ?? "Prev 7 Days" });
    const dispatch = useDispatch();
    const filterPathname = campaignId ?? linkId;
    const currencySymbol = localStorage.getItem("currency_symbol");
    const currencySymbolOutput = (<span dangerouslySetInnerHTML={{__html: currencySymbol}}></span>);
    const [isModalOpen, setIsModalOpen] = React.useState(false);
    const [maxIcon, setMaxIcon] = React.useState(false);
    const [bumpMaxIcon, setBumpMaxIcon] = React.useState(false);
    const [bumpGraphModal, setBumpGraphModal] = React.useState(false);
    const [baseURL, setBaseURL] = React.useState(`/afp/current/campaign`);
    const detectModes = useSelector(state => state?.detectModes);

    const handleMaximizeClick = () => {
        setIsModalOpen(!isModalOpen);
    };
    const handleBumpGraphMaximizeClick = () => {
        setBumpGraphModal(!bumpGraphModal)
    };

    React.useMemo(() => {
        adNetworks?.map(i => {
            if (!currentData[i]?.summary || currentData[i]?.summary === undefined) {
                setLoading(true);
                CurrentData({ adType: i, timeRange: timeRange.timeRange, campaignId, linkId }, dispatch).then(() => {
                    setLoading(false);
                    setError('');
                }).catch((e) => {
                    setLoading(false);
                    getErrorMessage(e)
                });
            }
        })

    }, [adNetworks.length]);

    const getErrorMessage = (error) => {

        if (primaryUser && error?.response?.status === 403) {
            setSupportLink("Website Settings")
            setError("The connection to your Veracity Ad Protection account has expired. Visit Website Settings to reconnect.")
        } else if (!primaryUser && error?.response?.status === 403) {
            setError("The connection to your Veracity Ad Protection account has expired. The primary user on your account must reconnect in Website Settings.")
        }
        else {
            setSupportLink("Contact Support")
            setError("Sorry, we’re having trouble loading your Veracity Ad Protection Account, if this problem persists please contact us for support.")
        }

    };

    const updateTimeRange = (timeRange) => {
        setTimeRange(timeRange);
        setLoading(true);
        setBaseURL(`/afp/current/campaign`);
        if (campaignId) {
            setBaseURL(`/afp/current/link`);
        }
        adNetworks.map(i => {
            if (adType == -1 || adType === i) {
                CurrentData({ adType: i, timeRange: timeRange.timeRange, campaignId, linkId }, dispatch).then(() => {
                    setLoading(false);
                    setError('');
                }).catch((e) => {
                    setLoading(false);
                    setError(`Failed to change time range : ${e}`)
                });
            }
        })
    };


    React.useMemo(() => {
        updateTimeRange(timeRange);
    }, [campaignId, linkId]);

    return (
        <Tile error={error} showAdnetworkPicker={!(campaignId || linkId)} adNetworks={adNetworks} supportLink={supportLink} dispatchEvent="UPDATE_CURRENT_ADNETWORK" DropFunc={() => { }} DragFunc={() => { }} timeRange={timeRange} setTimeRange={updateTimeRange} dragged={null} enableDateFilter={true} DisplayDashboard={false} graph={filterPathname ? "Current" : 'Current Period'}>
            {adNetworks.map((i, j) => {
                if ((campaignId || linkId) && i !== adType) return null;
                const hP = currentData[i]?.summary?.human_percentage;
                const selectedNetwork = Adnetworks.find(nt => nt.id === i);
                const cHP = currentData[i]?.summary?.change_in_human_percentage;
                const humans = currentData[i]?.summary?.humans;
                const adLabel = selectedNetwork?.label
                const adIcon = selectedNetwork?.icon;
                const adHeadingBackGroundColor = selectedNetwork?.backgroundColor;
                const effectiveSpend = (currentData[i]?.summary.spend - currentData[i]?.summary.wasted_spend).toFixed(2);
                const savings = (currentData[i]?.summary?.savings || 0).toFixed(2);
                const dataAvailable = currentData[i]?.values.length;
                const costPerHumanVisit = currentData[i]?.summary?.human_click_cost;
                return (
                    <>
                        {filterPathname ? <Breadcrumb baseURL={'/afp/current'} linkId={linkId} adType={adType} adIcon={adIcon} values={currentData[i].values} /> : <h2 className="adNetworkHeading" style={{ background: adHeadingBackGroundColor }}>{adIcon}{adLabel}</h2>}
                        <div key={j} className="grid">
                            <div className='item-1 graph'>
                                <div className="graph-header">
                                    <div className="graph-heading">Traffic funnel</div>
                                    <GraphsToolTip message={["Paid clicks:<br/>the number of clicks on your ads as reported by your ad network.", "Landed clicks:<br/>the total number of landings detected from your ads.", "Human visits:<br/>verified humans who have landed from your ads.", "Engaged humans:<br/>the number of humans who have engaged with the content on your landing page."]} />
                                </div>{loading ? <Loader /> : <TrafficFunnel data={currentData[i]?.summary} />}
                            </div>
                            <div className="bitem-3 graph" onMouseEnter={() => setMaxIcon(true)} onMouseLeave={() => setMaxIcon(false)}>
                                <div className="graph-header">
                                    <div className="graph-heading">Total Visits and Clicks</div>
                                    <GraphsToolTip message={["Paid clicks:<br/>the number of clicks on your ads as reported by your ad network.", "Landed clicks:<br/>the total number of landings detected from your ads.", "Human visits:<br/>verified humans who have landed from your ads."]} />
                                    {maxIcon &&
                                        <div className="max-icon" style={{ marginTop: 7 }} onClick={handleMaximizeClick} title="Expand Graph">
                                            <MaxIcon />
                                        </div>
                                    }
                                </div>
                                {loading ? <Loader /> : <ClicksVisitsLineGraph data={currentData[i]?.clicks} botCentric={false} />}
                                {isModalOpen &&
                                    <GraphModal
                                        isOpen={isModalOpen}
                                        onClose={handleMaximizeClick}
                                        graph={<ClicksVisitsLineGraph data={currentData[i]?.clicks} botCentric={false} />}
                                        title="Total Visits and Clicks"
                                    />
                                }
                            </div>

                            {dataAvailable ? <div className="item-5" >

                                <ValueCard className="small" loading={loading} title={hP ? `${hP}%` : null} subTitle={humans ? `Humans: ${formatNumber(humans)}` : null}>
                                    <IncreaseIndicator value={cHP} tooltip="Percentage change in the human traffic compared to baseline value" />
                                </ValueCard>
                                <ValueCard className="small" loading={loading} title={[currencySymbolOutput, formatCurrency(currentData[i]?.summary.spend)]} subTitle={'Spend'}></ValueCard>
                                <ValueCard className="small" loading={loading} title={[currencySymbolOutput, formatCurrency(effectiveSpend)]} subTitle={'Spend on human visits'}></ValueCard>
                                <ValueCard className="small" loading={loading} title={[currencySymbolOutput, formatCurrency(costPerHumanVisit)]} subTitle='Cost Per Human Visit'></ValueCard>
                                {(savings > 0 && detectModes?.data?.afp_status !== "detect") &&
                                    <ValueCard className="small" loading={loading} title={[currencySymbolOutput, formatCurrency(savings)]} subTitle={'Reinvested budget'}></ValueCard>
                                }

                            </div> : <></>}
                            {!linkId && <ActiveCampaignPanel loading={loading} className='item-6' adType={i} data={currentData} baseURL={baseURL} />}

                        </div>
                    </>)
            }
            )}
        </Tile>
    )
}


export default CurrentTile;
